import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideCore } from './core/core';
import { errorInterceptor } from 'libs/core/src/lib/interceptors/error.interceptor';
import { jwtInterceptor } from 'libs/core/src/lib/interceptors/jwt.interceptor';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeSr from '@angular/common/locales/sr';
import localeCyr from '@angular/common/locales/sr-Cyrl';

registerLocaleData(localeEn);
registerLocaleData(localeSr);
registerLocaleData(localeCyr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideCore({ routes }),
    provideHttpClient(withInterceptors([jwtInterceptor, errorInterceptor])),
    {
      provide: LOCALE_ID,
      useFactory: (translateService: TranslateService) =>
        translateService.getCurrentLang() || translateService.getFallbackLang(),
      deps: [TranslateService],
    },
  ],
};
